import { ERR_INVALID_ARGUMENT } from "../utils/error";
import { Vector3, Quaternion } from "@babylonjs/core/Maths/math.vector";
import * as basket from "../eaiws/basket";
import { eq } from "../utils/math";
export class Helpers {
    static Vector3FromEaiwsVector(pEVec) {
        const tV = new Vector3();
        Helpers.Vector3CopyFromEaiwsVector(tV, pEVec);
        return (tV);
    }
    static Vector3CopyFromEaiwsVector(pVec3, pEVec) {
        if (pEVec != null) {
            pVec3.x = pEVec.x;
            pVec3.y = pEVec.y;
            pVec3.z = -pEVec.z;
        }
        else {
            pVec3.set(0, 0, 0);
        }
    }
    static QuaternionFromEaiwsRotation(pERot) {
        if (pERot == null || pERot.axis == null || eq(pERot.angle, 0.0)) {
            return (new Quaternion());
        }
        else {
            return (Quaternion.RotationAxis(new Vector3(pERot.axis.x, pERot.axis.y, -pERot.axis.z), -pERot.angle));
        }
    }
    static getOfmlUpdateState(pSession, pBasketId) {
        if (pSession == null || pBasketId == null)
            return (Promise.reject(new Error(ERR_INVALID_ARGUMENT)));
        //query state
        const tOptions = new basket.UpdateBasketArticlesOptions();
        tOptions.migrate = false;
        tOptions.update = false;
        const tPromise = pSession.basket.updateBasketArticles([pBasketId], null, tOptions).then((pResult) => {
            if (pResult != null && pResult.length > 0)
                return (pResult[0].updateState);
            else
                return ("Unknown");
        });
        return (tPromise);
    }
    static updateOfmlArticle(pSession, pBasketId, pMigrate, pPriceDate) {
        const tOptions = new basket.UpdateBasketArticlesOptions();
        tOptions.migrate = pMigrate;
        tOptions.update = true;
        tOptions.wholeComposite = true;
        tOptions.priceDate = pPriceDate;
        const tPromise = pSession.basket.updateBasketArticles([pBasketId], null, tOptions).then((pResult) => {
            let tState = "Unknown";
            if (pResult != null) {
                for (const tRes of pResult) {
                    if (tRes.itemId === pBasketId) {
                        tState = tRes.updateState;
                        break;
                    }
                }
            }
            return (tState);
        });
        return (tPromise);
    }
}
